import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { lastValueFrom, timeout } from 'rxjs';
import { PaymentService } from 'app/services/payment.service';
import { SubscriptionService } from 'app/services/subscription.service';
import Swal, { SweetAlertIcon, SweetAlertPosition } from 'sweetalert2';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ProfileManagementService } from 'app/services/profile-management.service';
import { AuthService } from 'app/core/auth/auth.service';
import { Capacitor } from '@capacitor/core';
declare var clarity: any;
export const gtag = (...args: any[]) => {
    if (window['dataLayer']) {
      window['dataLayer'].push(args);
    } else {
      console.log('Google Analytics is not properly initialized');
    }
  };
@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ]
})
export class SharedMethods {
    public paymentObject: object;
    public options: object;
    public payload: object;
    public subPrice: number;
    private isNative = Capacitor.isNativePlatform();

    constructor(
        private _paymentService: PaymentService,
        private _subscriptionService: SubscriptionService,
        private _router: Router,
        private location: Location,
        private _managementService: ProfileManagementService,
        private _authService: AuthService
    ) {

      }


      set sessionState(value: any) {
        sessionStorage.setItem("activeSessionState", "true");
      }


      get sessionState(): any {
        const storedValue = sessionStorage.getItem("activeSessionState");
        if(storedValue){
            return true;
        }else{
            return false;
        }
      }


    public async processPayment(user: { name: string, surname: string, email: string, coupon?: string }, userId: number, subType: string, voucher: number, voucherAmount: number = null): Promise<any> {
        return await new Promise<any>(async (resolve, reject) => {
        
            if (!this._paymentService.subscriptionDetails) {
                return reject('Subscription details not found');
                
            }
          
            if (this._paymentService.subscriptionDetails.row.recurrence.toLowerCase() === "trial") {
                return resolve("trial");
            }

            try {
                const paymentResponse = await this.dataToCreatePayment(user, userId, voucher, voucherAmount);
                
                // Check if the response has the expected structure
                if (!paymentResponse?.data?.reference?.instanceId) {
                    console.error('Invalid payment response:', paymentResponse);
                    return reject('Failed to create payment. Please check your information and try again.');
                }
                
                const paymentId = paymentResponse.data.reference.instanceId;

                if (!paymentId) {
                    return reject('Payment ID not found');
                }

                const paymentResult = await this.completePayment(paymentId);

                if (paymentResult === 'complete') {
                    const result = await lastValueFrom(this._paymentService.dataToViewPayment(paymentId))
                    .catch(()=>{
                        Swal.fire({
                            title: 'Error!',
                            text: "An Error has occurred, Please try again later or contact support.",
                            icon: 'error',
                            confirmButtonText: 'OKAY',
                            customClass: {
                              htmlContainer: 'text-3xl',
                              confirmButton: 'custom-button'
                            }
                          }).then(() => {
                            // `/member/support` is NOT a registered route (verified against
                            // the live router config) — navigating there after a payment
                            // error dead-ended the user in
                            // `NG04002: Cannot match any routes`, on top of the failure they
                            // had just hit. Send them somewhere real instead; the error
                            // dialog above has already told them what happened.
                            // TODO(demo): restore a dedicated support route/screen if one is
                            // reinstated.
                            this._router.navigateByUrl(`/member/home`);
                          });
                    });

                    resolve(result);
                } else {
                    reject("Payment error");
                }
            } catch (error) {
                console.error('Process payment error:', error);
                reject(error?.message || 'An error occurred during payment processing');
            }
        })
    }


    private async completePayment(paymentId: any): Promise<any> {
        return await new Promise<any>(async (resolve, reject) => {
            const response = await lastValueFrom(this._paymentService.dataToViewPayment(paymentId))
            .catch(()=>{
                 return null;
            });
            if (!response) {
                resolve("Payment failed");
            }

            

            const paymentIdentifier = response.data.data.payment_identifier;
            this.paymentObject = response.data.data;
            
            // Calculate and store scrollbar width before PayFast opens
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
            document.body.classList.add('payfast-open');
            
              window['payfast_do_onsite_payment']({ "uuid": paymentIdentifier }, function (result) {
                console.error(result);
                    
                    // Remove payfast-open class to restore normal scrolling
                    document.body.classList.remove('payfast-open');
                    document.documentElement.style.removeProperty('--scrollbar-width');

                    if (result === null) {
                        this.showSpinner = false;
                        resolve("incomplete");
                        window.close();
                    } else if (result === true) {
                        resolve("complete");
                    } else {
                        this.showSpinner = false;
                        resolve("Payment failed");
                    }
                }.bind(this));
        });
    }

    private async dataToCreatePayment(user: any, userId: number, voucher: number, voucherAmount: number) {
       
        if (voucherAmount) {
            this.subPrice = voucherAmount
        } else {
            this.subPrice = this._paymentService.subscriptionDetails.row.price
        }

        this.payload = {
            payment: {
                ref_subscription: this._paymentService.subscriptionDetails.id,
                name: user.name,
                surname: user.surname,
                email: user.email,
                amount: this.subPrice,
                ref_user: userId,
                ref_ind_voucher: voucher,
                ...(user.coupon ? { coupon: user.coupon } : {}) 
            }
        };


        const response = await lastValueFrom(this._paymentService.createPayment(this.payload))
            .catch(() => {
                return "Payment error"
            });
            return response;
        }

    public goBack(){
        this.location.back();
    }

    public goHome(){
        this._router.navigateByUrl(`/sign-in`);
    }


    public navigate(url: string){
        this._router.navigateByUrl(url);
    }

  

  public async showNotification(response,
     error:boolean = false,
     toast:boolean = false,
     time:number = 3000,
     position:string = "center",
     textSize:string = "text-2xl",
     customTitle: string = null,
     confirmButton: boolean = false
     ) {
    return new Promise<void>((resolve) => {
        let title: string = response?.status == "success" ? "Success" : "Error!";
        let message: string;
        let messageText: string;
        let icon: any = response?.status == "success" ? "success" : "error" as SweetAlertIcon
        if(typeof response === 'string'){
            if(error){
                title = "Error";
                message = response;
                icon = "error"
            }else{
                title = "Success";
                message = response;
                icon = "success"
            }
        }else{
            if(response?.error?.message){
                if(!response?.error?.data['~']){
                    messageText = response?.error?.data.email ?? response?.error?.data[0];
                }else{
                    messageText = response?.error?.data['~'];
                }
                message = response?.error?.message + ": " + messageText;
            }else{
                message = response?.message;
            }
        }
      const config = {
        title: customTitle != null ? customTitle : title,
        html: message,
        icon: icon,
        toast: toast,
        confirmButtonText: 'OKAY',
        showConfirmButton: confirmButton,
        timer: time,
        position: position as SweetAlertPosition,
        customClass: {
          htmlContainer: textSize,
          confirmButton: "custom-button",
        },
      };
      Swal.fire(config).then(() => {
        resolve(); 
      });
    });
  }


  public microsoftClarity(action: string){
    // Check if clarity is available before using it
    if (typeof clarity === 'undefined' || !clarity) {
      console.warn('Microsoft Clarity is not loaded. Skipping analytics tracking for action:', action);
      return;
    }

    switch (action) {
        case "video":
            clarity('set', 'Reflection Listen' + '' + 'button', 'clicked');
            break;
        case "read":
            clarity('set', 'Reflection Read' + '' + 'button', 'clicked');
            break;
        case "listen":
            clarity('set', 'Reflection Watch' + '' + 'button', 'clicked');
            break;
        case 'thoughtAudio':
            clarity('set', 'Thought Listen' + '' + 'button', 'clicked');
            break;
        case 'thoughtImage':
            clarity('set', 'Thought Image' + '' + 'button', 'clicked');
            break;
        case 'thoughtVideo':
            clarity('set', 'Thought Video' + '' + 'button', 'clicked');
             break;
        case 'plansNavigate':
            clarity('set', 'Navigated To Plans Page' + '' + 'button', 'clicked');
            break;
        case 'startJourney':
            clarity('set', 'Start Journey/Sign Up' + '' + 'button', 'clicked');
            break;

        default:
            break;
    }   
  }


  public trackEvent(eventName: string, eventParams: { [key: string]: any }) {
 
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({
    //     event: eventName,  
    //     ...eventParams     
    //   });

  }

  public async subscriptionChecker(subType?: string){
    subType = subType ?? sessionStorage.getItem("package");

    // Don't allow signup without a package selection
    if (!subType) {
      throw new Error("No subscription package selected");
    }

    const response = await lastValueFrom(this._subscriptionService.gridSubscription())
    .catch(()=>{
        return null;
    });
    this._paymentService.subscriptionDetails = response.data.records.find(element => subType === element.row.recurrence.toLowerCase());
    return this._paymentService.subscriptionDetails;
  }
}


declare global {
    interface Window {
      dataLayer: any[];
    }
  }